__webpack_require__.p = "//digitkart.ai/";